"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExperimentScoringSchema = exports.ExperimentScoringKindSchema = exports.ExperimentScoringKind = void 0;
const z = require("zod");
const experiment_scores_1 = require("./experiment-scores");
var ExperimentScoringKind;
(function (ExperimentScoringKind) {
    ExperimentScoringKind["Initial"] = "initial";
    ExperimentScoringKind["Rescore"] = "rescore";
})(ExperimentScoringKind || (exports.ExperimentScoringKind = ExperimentScoringKind = {}));
exports.ExperimentScoringKindSchema = z.nativeEnum(ExperimentScoringKind);
exports.ExperimentScoringSchema = z.object({
    id: z.string(),
    experimentId: z.string(),
    kind: exports.ExperimentScoringKindSchema,
    datasetId: z.string(),
    scoredAt: z.date(),
    scoredByUserId: z.string().nullable(),
    overallScores: experiment_scores_1.ScoresSchema,
    carriedOverScoreKeys: z.string().array(),
});
//# sourceMappingURL=experiment-scoring.js.map